import { Dropdown } from 'primereact/dropdown';
import classes from './ndcHistoryTable.module.scss';
import { useNdcHistoryTable } from './useNdcHistoryTable';
import { Skeleton } from 'primereact/skeleton';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import deleteIcon from 'assets/icons/deleteIcon.svg';

const NdcHistoryTable = () => {
  const {
    isNdcHistoryLoading,
    dropDownDetailsOptions,
    selectedOption,
    tableData,
    dropDownUpdate,
    handleDeleteNdcHistory,
    checkIfCurrentRowIsBeingDelete,
    checkIfDeleteLoading,
  } = useNdcHistoryTable();
  return (
    <>
      {isNdcHistoryLoading ? (
        <Skeleton height="10rem" style={{ width: '100%' }} />
      ) : (
        <div className={classes.ndcHistoricalValuesContainer}>
          <div className={classes.ndcHistoryTableHeader}>
            <Dropdown
              style={{ width: '15rem' }}
              value={selectedOption}
              options={dropDownDetailsOptions}
              optionLabel="name"
              onChange={e => dropDownUpdate(e.target.value)}
              placeholder="Select strategy"
            />
          </div>

          {selectedOption?.code && (
            <div className={classes.tablesContainer}>
              <div className={classes.tablesContainerInstance}>
                <div className={classes.tableHeading}>{`Future ${selectedOption.name}`}</div>
                <table className={classes.datatable}>
                  <thead>
                    <tr>
                      <th>
                        {selectedOption.name === 'PPS Strategy & Reason'
                          ? 'PPS'
                          : selectedOption.name}
                      </th>
                      {selectedOption.name === 'PPS Strategy & Reason' && <th>PPS Reason</th>}
                      <th>Start Date</th>
                      <th>End Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.future.map((row, index) => (
                      <tr key={index}>
                        <td>{row.value}</td>
                        {selectedOption.name === 'PPS Strategy & Reason' && <td>{row.reason}</td>}
                        <td>{row.startDate}</td>
                        <td>{row.endDate}</td>

                        <td>
                          {!checkIfCurrentRowIsBeingDelete(row.id) ? (
                            <Button
                              disabled={checkIfDeleteLoading()}
                              onClick={() => handleDeleteNdcHistory(row.id as number)}
                              className={classes.deleteIconButton}
                              icon={<img src={deleteIcon} alt="delete" />}
                              rounded
                              text
                              aria-label="delete"
                            />
                          ) : (
                            <ProgressSpinner
                              style={{ width: '25px', height: '25px' }}
                              strokeWidth="8"
                              fill="var(--surface-ground)"
                              animationDuration="1s"
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className={classes.tablesContainerInstance}>
                <div className={classes.tableHeading}>{`Past ${selectedOption.name}`}</div>
                <table className={classes.datatable}>
                  <thead>
                    <tr>
                      <th>
                        {selectedOption.name === 'PPS Strategy & Reason'
                          ? 'PPS'
                          : selectedOption.name}
                      </th>
                      {selectedOption.name === 'PPS Strategy & Reason' && <th>PPS Reason</th>}
                      <th>Start Date</th>
                      <th>End Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.past.map((row, index) => (
                      <tr key={index}>
                        <td>{row.value}</td>
                        {selectedOption.name === 'PPS Strategy & Reason' && <td>{row.reason}</td>}
                        <td>{row.startDate}</td>
                        <td>{row.endDate}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default observer(NdcHistoryTable);
